import * as React from "react";
import { Outlet, useParams } from "react-router-dom";

import { useAuth, useNavigation } from "@/providers";

import { LoadingScreen } from "../../shared/components/LoadingScreen";

interface AuthenticationLayoutProps {
  isNotOrgProtected?: boolean;
}

export function AuthenticationLayout({
  isNotOrgProtected,
}: AuthenticationLayoutProps) {
  const {
    initialAuthCheckComplete,
    isAuthenticated,
    isLoading,
    getCurrentOrganization,
  } = useAuth();
  const { goto } = useNavigation();
  const currentOrg = getCurrentOrganization();
  // Every destination this layout guards names its own resume parameter, so they cannot collide
  // here even though one layout serves them all.
  const { inviteId, slackLinkNonce } = useParams();

  React.useEffect(() => {
    if (isLoading || !initialAuthCheckComplete) {
      return;
    }

    if (!isAuthenticated) {
      // Carry whichever resume parameter this route has, whether or not it needs an org: both are
      // undefined on the routes that have neither, and a signed-out person following a link should
      // land back on it rather than on the dashboard.
      goto.signIn({ inviteId, slackLinkNonce });
    } else if (currentOrg === null && !isNotOrgProtected) {
      goto.signIn({ chooseOrg: true });
    }
  }, [
    initialAuthCheckComplete,
    isAuthenticated,
    isLoading,
    currentOrg,
    isNotOrgProtected,
    goto,
    inviteId,
    slackLinkNonce,
  ]);

  const orgValid = currentOrg !== null || isNotOrgProtected;

  if (isAuthenticated && orgValid) {
    return <Outlet />;
  } else {
    return <LoadingScreen />;
  }
}
